/* Featured Collection - Tabbed */
// Runs only when sections/header.liquid has defer_header_drawers enabled.
// If that flag is set to false, the theme falls back to the original eager drawer setup.
function initDeferredHeaderDrawers() {
  const deferredContainer = document.querySelector('[data-deferred-header-drawers]');
  const deferredTemplate = document.querySelector('[data-deferred-header-drawers-template]');

  if (!deferredContainer || !deferredTemplate || deferredContainer.dataset.initialized === 'true') {
    return;
  }

  let loadingPromise;

  const initThemeDrawers = () => {
    if (!window.theme) {
      return;
    }

    const navDrawer = document.getElementById('NavDrawer');
    if (navDrawer && typeof theme.Drawers === 'function') {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
      if (theme.collapsibles && typeof theme.collapsibles.init === 'function') {
        theme.collapsibles.init(navDrawer);
      }
    }

    const cartDrawer = document.getElementById('CartDrawer');
    if (
      cartDrawer &&
      theme.settings &&
      theme.settings.cartType === 'drawer' &&
      !document.body.classList.contains('template-cart') &&
      typeof theme.CartDrawer === 'function'
    ) {
      theme.cartDrawerInstance = new theme.CartDrawer();
    }
  };

  const mountMarkup = (markup) => {
    deferredContainer.innerHTML = markup;
    deferredContainer.dataset.initialized = 'true';
    initThemeDrawers();
    initCartDrawerUI();
    initUpsellDrawers();
  };

  const loadDrawers = () => {
    if (deferredContainer.dataset.initialized === 'true') {
      return Promise.resolve();
    }

    if (loadingPromise) {
      return loadingPromise;
    }

    loadingPromise = Promise.resolve(deferredTemplate.innerHTML)
      .then((markup) => {
        mountMarkup(markup);
      })
      .catch((error) => {
        console.error('Unable to load deferred header drawers.', error);
      });

    return loadingPromise;
  };

  const openRequestedDrawer = (trigger) => {
    if (!trigger) {
      return;
    }

    if (trigger.classList.contains('js-drawer-open-nav')) {
      theme.NavDrawer?.open();
      return;
    }

    if (trigger.classList.contains('js-drawer-open-cart')) {
      document.dispatchEvent(new CustomEvent('cart:open'));
    }
  };

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.js-drawer-open-nav, .js-drawer-open-cart');

    if (!trigger || deferredContainer.dataset.initialized === 'true') {
      return;
    }

    event.preventDefault();
    loadDrawers().then(() => openRequestedDrawer(trigger));
  }, true);

  document.addEventListener('mouseover', function (event) {
    const trigger = event.target.closest('.js-drawer-open-nav, .js-drawer-open-cart');

    if (!trigger || deferredContainer.dataset.initialized === 'true') {
      return;
    }

    loadDrawers();
  });

  document.addEventListener('focusin', function (event) {
    const trigger = event.target.closest('.js-drawer-open-nav, .js-drawer-open-cart');

    if (!trigger || deferredContainer.dataset.initialized === 'true') {
      return;
    }

    loadDrawers();
  });

  const scheduleIdleLoad = () => {
    if (deferredContainer.dataset.initialized === 'true') {
      return;
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => loadDrawers(), { timeout: 2500 });
      return;
    }

    window.setTimeout(loadDrawers, 1500);
  };

  if (document.readyState === 'complete') {
    scheduleIdleLoad();
  } else {
    window.addEventListener('load', scheduleIdleLoad, { once: true });
  }
}

function loadFeaturedCollectionTab(tabPanel) {
  if (!tabPanel || tabPanel.dataset.loaded === 'true') {
    return;
  }

  const template = tabPanel.querySelector('.fct--template');

  if (!template) {
    tabPanel.dataset.loaded = 'true';
    return;
  }

  tabPanel.insertAdjacentHTML('afterbegin', template.innerHTML);
  template.remove();
  tabPanel.dataset.loaded = 'true';

  if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
    window.theme.reinitProductGridItem(tabPanel);
  }
}

document.querySelectorAll('.fct--button').forEach(btn => {
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    if (!e.currentTarget.classList.contains('fct--active')) {
      let context = btn.closest('.featured-collection--tabbed');
      let targetPanel = context.querySelector(`.fct--products--${btn.getAttribute('data-index')}`);

      loadFeaturedCollectionTab(targetPanel);

      context.querySelectorAll('.fct--products').forEach(itm => {
        itm.classList.add('fct--hide');
      })
      context.querySelector('.fct--active').classList.remove('fct--active');
      btn.classList.add('fct--active');
      targetPanel.classList.remove('fct--hide');
    }
  })
})


// PLP Subcollections dropdown

let subcolToggle = document.querySelector('.col-subcollections-toggle');

subcolToggle?.addEventListener('click', function (e) {
  let subcolCont = document.querySelector('.col-subcollections');
  if (subcolCont.getAttribute('data-active') === "true") {
    subcolCont.setAttribute('data-active', false);
  } else {
    subcolCont.setAttribute('data-active', true);
  }
});

// Terms and Conditions checkbox scroll if unclicked
function initCartDrawerUI() {
  const cartDrawer = document.querySelector('#CartDrawer');

  if (cartDrawer && cartDrawer.dataset.uiBound !== 'true') {
    cartDrawer.addEventListener('click', function (e) {
      let trgt = e.target;
      if (trgt.closest('button.cart__checkout')) {
        if (document.querySelector('.refund-policy-checkbox') && !document.querySelector('.refund-policy-checkbox').checked) {
          document.querySelector('.cart-attribute-returns label')?.classList.add('checkbox-error');
          document.querySelector('button.cart__checkout')?.classList.remove('btn--loading');
          e.preventDefault();
          let element = document.getElementById('policyLabel');
          element?.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          });
          return false;
        }
      }
    });

    cartDrawer.dataset.uiBound = 'true';
  }

  const refundPolicyCheckbox = document.querySelector('.refund-policy-checkbox');
  if (refundPolicyCheckbox && refundPolicyCheckbox.dataset.uiBound !== 'true') {
    refundPolicyCheckbox.addEventListener('change', function () {
      if (!this.checked) {
        document.querySelector('.cart-attribute-returns label')?.classList.remove('checkbox-error');
      }
    });

    refundPolicyCheckbox.dataset.uiBound = 'true';
  }

  const noteEl = document.querySelector('.cart-order-note textarea');
  const checkboxEl = document.querySelector('#cart-note-checkbox');
  if (noteEl && checkboxEl && checkboxEl.dataset.uiBound !== 'true') {
    let noteContent = noteEl.value;
    let orderNoteChecked = checkboxEl.checked;

    checkboxEl.addEventListener('click', function () {
      if (orderNoteChecked === true) {
        noteContent = noteEl.value;
        noteEl.removeAttribute('expanded');
        noteEl.value = "";
        orderNoteChecked = false;
      } else {
        noteEl.setAttribute('expanded', '');
        noteEl.value = noteContent;
        orderNoteChecked = true;
      }
    });

    checkboxEl.dataset.uiBound = 'true';
  }

  const clearCartButton = document.querySelector('.clear-cart');
  if (clearCartButton && clearCartButton.dataset.uiBound !== 'true') {
    clearCartButton.addEventListener('click', function(e) {
      e.preventDefault();
      showClearCartConfirm(function() {
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            if (document.querySelector('.clear-cart-page')) {
              location.reload();
            } else {
              document.dispatchEvent(new CustomEvent('cart:build'));
            }
          })
          .catch(error => {
            console.error('Error clearing the cart:', error);
          });
      });
    });

    clearCartButton.dataset.uiBound = 'true';
  }
}

let clearCartConfirmOverlay;
function showClearCartConfirm(onConfirm) {
  if (!clearCartConfirmOverlay) {
    clearCartConfirmOverlay = document.createElement('div');
    clearCartConfirmOverlay.className = 'clear-cart-confirm-overlay';
    clearCartConfirmOverlay.hidden = true;
    clearCartConfirmOverlay.innerHTML = `
      <div class="clear-cart-confirm-dialog" role="alertdialog" aria-modal="true" aria-labelledby="ClearCartConfirmMessage">
        <p id="ClearCartConfirmMessage">Are you sure you want to remove all items from your cart?</p>
        <div class="clear-cart-confirm-actions">
          <button type="button" class="btn btn--secondary" data-clear-cart-cancel>Cancel</button>
          <button type="button" class="btn" data-clear-cart-confirm-btn>Clear Cart</button>
        </div>
      </div>
    `;
    document.body.appendChild(clearCartConfirmOverlay);

    clearCartConfirmOverlay.addEventListener('click', function(e) {
      if (e.target === clearCartConfirmOverlay || e.target.hasAttribute('data-clear-cart-cancel')) {
        hideClearCartConfirm();
      }
    });
  }

  clearCartConfirmOverlay.querySelector('[data-clear-cart-confirm-btn]').onclick = function() {
    hideClearCartConfirm();
    onConfirm();
  };

  clearCartConfirmOverlay.hidden = false;
}

function hideClearCartConfirm() {
  if (clearCartConfirmOverlay) {
    clearCartConfirmOverlay.hidden = true;
  }
}

initCartDrawerUI();
initDeferredHeaderDrawers();

// Tooltips
function positionTooltipLeftOrRight(targetElement, tooltipElement) {
  const targetRect = targetElement.getBoundingClientRect();
  const tooltipRect = tooltipElement.getBoundingClientRect();
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  const tooltipWidth = 300;

  let tooltipX;

  if (targetRect.left - tooltipWidth >= 0) {
    // Place tooltip to the left of the target element
    // tooltipX = targetRect.left - tooltipWidth;
  } else if (targetRect.left + targetRect.width + tooltipWidth <= viewportWidth) {
    // Place tooltip to the right of the target element
    tooltipX = targetRect.left;
    tooltipElement.style.left = 0;
    tooltipElement.style.right = "unset";
  } else {
    // Default to placing tooltip on the left
    // tooltipX = targetRect.left - tooltipWidth;
  }
}

// Upsells - drawer
let variants = [];
let currentVariant;
let container = document.querySelector('#upsell-modal');
let originalSelectorId = "[data-product-select]";
function initUpsellDrawers() {
  let upsellDrawers = document.querySelectorAll('.upsell-drawer');
  upsellDrawers.forEach(drw => {
    if (drw.dataset.uiBound === 'true') {
      return;
    }

    drw.querySelector('.upsell-toggle')?.addEventListener('click', function () {
      if (drw.getAttribute('data-active') !== "true") {
        drw.setAttribute('data-active', "true");
      } else {
        drw.setAttribute('data-active', "false");
      }
    });

    drw.querySelector('.upsell-heading')?.addEventListener('click', function (e) {
      if (window.innerWidth <= 768) {
        let parent = e.currentTarget.closest('.upsell-drawer');
        if (parent.dataset.expanded === "true") {
          parent.dataset.expanded = "false";
        } else {
          parent.dataset.expanded = "true";
        }
      }
    });

    drw.addEventListener('click', function (e) {
      let productItem = e.target.closest('[data-product-handle');
      if (!productItem) {
        return;
      }
      var productHandle = productItem.getAttribute('data-product-handle');
      var productId = productItem.getAttribute('data-product-id');
      var productTemplateURL = `/products/${productHandle}?view=upsell-modal`;


      fetch(productTemplateURL).then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      }).then(function (data) {
        fetch(`/products/${productHandle}.json`).then(function (response) {
          var productModal = document.querySelector('#upsell-modal');
          productModal.querySelector('.upsell-inner').innerHTML = data;
          productModal.classList.add('upsell-modal--active');
          return response.json();
        }).then(function (rspns) {
          variants = rspns.product.variants;
          currentVariant = getVariantFromOptions(variants);

          /* For bundle products */
          if (rspns.product.template_suffix === "custom-bundle" || rspns.product.template_suffix === "custom-bundle-grid" ) {

            let mappingEls = document.querySelectorAll("#bundUp-data .bundUp_item-data");
            let mappings = {};
            mappingEls.forEach(itm => {
              mappings[itm.getAttribute('data-key')] = itm.getAttribute('data-value');
            });
            let selectedVar = currentVariant.id;
            let available = false;

            setTimeout(function () {
              const btn = document.querySelector("button[data-add-to-cart].bndUp-btn");
              const btnLabel = document.querySelector('.bndUp-btn [data-add-to-cart-text]');
              const availabilityData = JSON.parse(container.querySelector('#bundle-availability-data').textContent);
              const available = availabilityData[selectedVar];
            
              const labels = container.querySelector(`.upsell-variant-hidden[data-id="${selectedVar}"]`)?.dataset || {};

              if (!available || currentVariant.sku.indexOf('NONCOMPL-') !== -1) {
                btn.classList.add('disabled');
                btn.setAttribute('disabled', '');
                btnLabel.textContent = labels.unavailableLabel || "Sold out";
              } else {
                btn.classList.remove('disabled');
                btn.removeAttribute('disabled');
                btnLabel.textContent = labels.atcLabel || "Add to cart";
              }
            
              btn.addEventListener('click', function (e) {
                e.preventDefault();
                doStuff(btn);
              });

              updateUpsellBundleContents(selectedVar);
              updateUpsellBundleSwatches(currentVariant);
            }, 1);

            function doStuff(elm) {
              elm.querySelector('span').innerText = "Adding...";
              let newObj = [];
              let selected = mappings[currentVariant.id].split(",");
              let upsellType = elm.closest('form').querySelector('#upsell').getAttribute('value');
              selected.forEach(itm => {
                newObj = [...newObj, { "id": itm, "quantity": 1, "properties": { "_Bundle listing?": "Yes", "_Upsell?": upsellType } }]
              })
              let formData = { "items": newObj };

              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
                .then(response => {
                  if (response.ok) {
                    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {}));
                    return response.json();
                  }
                  return Promise.reject(response);
                })
                .then(response => {
                  document.querySelector('#upsell-modal .upsell-inner').innerHTML = "";
                  document.querySelector('#upsell-modal').classList.remove('upsell-modal--active');
                  document.dispatchEvent(new CustomEvent('cart:build'));
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
            }
          }
          else {
            let form = container.querySelector('form');
            form.addEventListener("submit", function (e) {
              e.preventDefault();
              let data = new FormData(form);

              fetch('/cart/add.js', {
                method: 'POST',
                body: data,
                headers: {
                  'X-Requested-With': 'XMLHttpRequest'
                }
              })
                .then(response => response.json())
                .then(data => {
                  // Handle the response, e.g., show a success message or update the cart icon
                  if (document.body.classList.contains('template-cart')) {
                    location.reload();
                  } else {
                    // Handle the response, e.g., show a success message or update the cart icon
                    document.querySelector('#upsell-modal .upsell-inner').innerHTML = "";
                    document.querySelector('#upsell-modal').classList.remove('upsell-modal--active');
                    document.dispatchEvent(new CustomEvent('cart:build'));
                  }
                })
                .catch(error => {
                  console.error('Error:', error);
                });
            })
          }
        }).catch(function (error) {
          console.error('Error fetching product template:', error);
        });
      });
    });

    drw.dataset.uiBound = 'true';
  });
}

initUpsellDrawers();

window.addEventListener('load', function () {
  let bundles = document.querySelectorAll('.pdp__bundle');
  bundles.forEach(drw => {
    drw.querySelector('button').addEventListener('submit', function (e) {
      e.preventDefault();
    })
  })
  bundles.forEach(drw => {
    drw.querySelector('.pdp__bundle--button').addEventListener('click', function (e) {
      e.preventDefault();
      let productItem = drw.closest('.pdp__bundle');
      if (!productItem) {
        return;
      }
      var productHandle = productItem.getAttribute('data-product-handle');
      var productId = productItem.getAttribute('data-product-id');
      var productTemplateURL = `/products/${productHandle}?view=bundle-modal`;


      fetch(productTemplateURL).then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      }).then(function (data) {
        fetch(`/products/${productHandle}.json`).then(function (response) {
          var productModal = document.querySelector('#upsell-modal');
          productModal.querySelector('.upsell-inner').innerHTML = data;
          productModal.classList.add('upsell-modal--active');
          return response.json();
        }).then(function (rspns) {
          variants = rspns.product.variants;
          currentVariant = getVariantFromOptions(variants);

          /* For bundle products */
          if (rspns.product.template_suffix === "custom-bundle" || rspns.product.template_suffix === "custom-bundle-grid" ) {

            let mappingEls = document.querySelectorAll("#bundUp-data .bundUp_item-data");
            let mappings = {};
            mappingEls.forEach(itm => {
              mappings[itm.getAttribute('data-key')] = itm.getAttribute('data-value');
            });
            let selectedVar = currentVariant.id;
            let available = false;

            setTimeout(function () {
              const btn = document.querySelector("button[data-add-to-cart].bndUp-btn");
              const btnLabel = document.querySelector('.bndUp-btn [data-add-to-cart-text]');
              const availabilityData = JSON.parse(container.querySelector('#bundle-availability-data').textContent);
              const available = availabilityData[selectedVar];
            
              const labels = container.querySelector(`.upsell-variant-hidden[data-id="${selectedVar}"]`)?.dataset || {};

              if (!available || currentVariant.sku.indexOf('NONCOMPL-') !== -1) {
                btn.classList.add('disabled');
                btn.setAttribute('disabled', '');
                btnLabel.textContent = labels.unavailableLabel || "Sold out";
              } else {
                btn.classList.remove('disabled');
                btn.removeAttribute('disabled');
                btnLabel.textContent = labels.atcLabel || "Add to cart";
              }
            
              btn.addEventListener('click', function (e) {
                e.preventDefault();
                doStuff(btn);
              });

              updateUpsellBundleContents(selectedVar);
              updateUpsellBundleSwatches(currentVariant);
            }, 1);

            function doStuff(elm) {
              elm.querySelector('span').innerText = "Adding...";
              let newObj = [];
              let selected = mappings[currentVariant.id].split(",");
              selected.forEach(itm => {
                newObj = [...newObj, { "id": itm, "quantity": 1, "properties": { "_Bundle listing?": "Yes", "_Upsell?": "PDP Upsell" } }]
              })
              let formData = { "items": newObj };


              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
                .then(response => {
                  if (response.ok) {
                    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {}));
                    return response.json();
                  }
                  return Promise.reject(response);
                })
                .then(response => {
                  document.querySelector('#upsell-modal .upsell-inner').innerHTML = "";
                  document.querySelector('#upsell-modal').classList.remove('upsell-modal--active');
                  document.dispatchEvent(new CustomEvent('cart:build'));
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
            }
          } else {
            let form = container.querySelector('form');
            form.addEventListener("submit", function (e) {
              e.preventDefault();
              let data = new FormData(form);

              fetch('/cart/add.js', {
                method: 'POST',
                body: data,
                headers: {
                  'X-Requested-With': 'XMLHttpRequest'
                }
              })
                .then(response => response.json())
                .then(data => {
                  // Handle the response, e.g., show a success message or update the cart icon
                  document.querySelector('#upsell-modal .upsell-inner').innerHTML = "";
                  document.querySelector('#upsell-modal').classList.remove('upsell-modal--active');
                  // document.dispatchEvent(new CustomEvent('cart:build'));
                  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {}));
                })
                .catch(error => {
                  console.error('Error:', error);
                });
            })
          }

        }).catch(function (error) {
          console.error('Error fetching product template:', error);
        });
      });
    });
  })
})


container.addEventListener('click', function (e) {
  const target = e.target.closest('.upsell-inner');
  if (target) {
    return
  }
  document.querySelector('#upsell-modal').classList.remove('upsell-modal--active');
})

document.addEventListener('click', function (e) {
  const target = e.target.closest('#upsell-modal .variant-input');

  if (target) {
    var variant = getVariantFromOptions(variants);

    if (!variant) {
      // Option combination with no matching variant: disable the button ("Unavailable")
      updateCartButton(null);
      updateUpsellBundleContents(null);
      return;
    }

    var color = target.querySelector('input').dataset.colorName;
    var index = target.querySelector('input').dataset.colorIndex;
    if (e.target.closest('[name="Color"]')) {
      updateColorName(color, index);
    }

    updateMasterSelect(variant);
    updateImage(variant);
    updatePrice(variant);
    updateCartButton(variant);
    updateUpsellBundleContents(variant.id);
    updateUpsellBundleSwatches(variant);
    currentVariant = variant;
  }
})

// Bundle upsell modal (snippets/product-form--upsell-bundle.liquid):
// show the selected variant's "What you'll get" list with each item's estimated ship date
// (hidden when the option combination has no matching variant)
function updateUpsellBundleContents(variantId) {
  const contents = container.querySelector('[data-upsell-bundle-contents]');
  if (!contents) return;

  let hasItems = false;
  contents.querySelectorAll('[data-upsell-bundle-contents-variant]').forEach(list => {
    const isSelected = list.dataset.upsellBundleContentsVariant === String(variantId);
    list.hidden = !isSelected;
    if (isSelected) hasItems = true;
  });
  contents.hidden = !hasItems;

  contents.querySelectorAll('[data-bundle-esd-item]').forEach(item => {
    const esd = item.querySelector('[data-bundle-esd]');
    const range = getAvailabilityRange(getAvailabilityDataFromElement(item));
    if (!esd || !range) return;
    esd.textContent = 'Estimated ship date is ' + formatAvailabilityRange(range.dateFrom, range.dateTo);
    esd.hidden = false;
  });
}

// Bundle upsell modal: cross out option values whose bundle variant has no available items.
// Same rules as updateSwatchAvailability() in snippets/product-form-bundle.liquid; replaces the
// Liquid "disabled" state, which is based on the bundle listing's own inventory.
function updateUpsellBundleSwatches(selectedVariant) {
  const availabilityEl = container.querySelector('#bundle-availability-data');
  // Only for the linked-products version of the bundle form (it renders [data-upsell-bundle-contents])
  if (!availabilityEl || !selectedVariant || !container.querySelector('[data-upsell-bundle-contents]')) return;

  const availabilityData = JSON.parse(availabilityEl.textContent);
  const optionsOf = v => [v.option1, v.option2, v.option3].filter(o => o !== null && o !== undefined);
  const currentOptions = optionsOf(selectedVariant);
  const numOptions = currentOptions.length;

  container.querySelectorAll('input[data-variant-input]').forEach(input => {
    const label = input.id ? container.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
    if (!label) return;

    const index = parseInt(input.dataset.index.replace('option', ''), 10) - 1;
    // Match this value with the other selected options; for 3-option products,
    // option 1 and 2 values count as available if any option 3 value is available
    const hasValidCombo = variants.some(v => {
      const opts = optionsOf(v);
      return opts[index] === input.value
        && opts.every((o, i) => i === index || (numOptions === 3 && index < 2 && i === 2) || o === currentOptions[i])
        && availabilityData[v.id];
    });

    input.classList.remove('disabled');
    label.classList.remove('disabled');
    label.classList.toggle('unavailable', !hasValidCombo);
    label.classList.toggle('crossed-out', !hasValidCombo);
  });
}

function updateImage(vr) {
  let imgs = container.querySelectorAll('.upsell-images img');
  imgs.forEach(img => {
    img.classList.add('hide');
    if (img.dataset.variants.includes(vr.id)) {
      img.classList.remove('hide')
    }
  })
}

function getCurrentOptions() {
  var result = [];

  document.querySelectorAll('#upsell-modal .variant-input input').forEach(el => {
    var type = el.getAttribute('type');

    if (type === 'radio' || type === 'checkbox') {
      if (el.checked) {
        result.push({
          value: el.value,
          index: el.dataset.index
        });
      }
    } else {
      result.push({
        value: el.value,
        index: el.dataset.index
      });
    }
  });



  // remove any unchecked input values if using radio buttons or checkboxes
  result = theme.utils.compact(result);
  return result;
};

function getVariantFromOptions(vrnts) {
  var selectedValues = getCurrentOptions();
  var variants = vrnts;
  var found = false;

  variants.forEach(function (variant) {
    var match = true;
    var options = variant.options;

    selectedValues.forEach(function (option) {
      if (match) {
        match = (variant[option.index] === option.value);
      }
    });

    if (match) {
      found = variant;
    }
  });

  return found || null;
}

function updatePrice(variant) {
  if (variant.price === currentVariant.price && variant.compare_at_price === currentVariant.compare_at_price) {
    return;
  }

  if (variant) {
    // Regular price
    container.querySelector('[data-product-price]').innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);

    // Sale price, if necessary
    if (variant.compare_at_price > variant.price) {
      container.querySelector('[data-compare-price]').innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
      container.querySelector('[data-product-price-wrap]').classList.remove('hide');
      container.querySelector('[data-product-price]').classList.add('on-sale');
      container.querySelector('[data-compare-price-a11y]').setAttribute('aria-hidden', 'false');
      container.querySelector('[data-a11y-price]').setAttribute('aria-hidden', 'false');

      var savings = variant.compare_at_price - variant.price;

      if (theme.settings.saveType == 'percent') {
        savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
      } else {
        savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
      }

      container.querySelector('[data-save-price]').classList.remove('hide');
      container.querySelector('[data-save-price]').innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
    } else {
      if (container.querySelector('[data-product-price-wrap]')) {
        container.querySelector('[data-product-price-wrap]').classList.add('hide');
      }
      container.querySelector('[data-save-price]').classList.add('hide');
      container.querySelector('[data-product-price]').classList.remove('on-sale');
      if (container.querySelector('[data-compare-price-a11y]')) {
        container.querySelector('[data-compare-price-a11y]').setAttribute('aria-hidden', 'true');
      }
      container.querySelector('[data-a11y-price]').setAttribute('aria-hidden', 'true');
    }
  }
}

function updateMasterSelect(variant) {
  container.querySelector(originalSelectorId).value = variant.id;
  // Force a change event so Shop Pay installments works after a variant is changed
  container.querySelector(originalSelectorId).dispatchEvent(new Event('change', { bubbles: true }));
}

function updateColorName(color, index) {
  container.querySelector(`[data-variant-color-label]` + `[data-index="${index}"]`).textContent = color;
}
function updateCartButton(variant) {
  var cartBtn = container.querySelector("[data-add-to-cart]");
  var cartBtnText = container.querySelector("[data-add-to-cart-text]");
  document.querySelector('.explainer-box')?.remove();
  cartBtn.closest('.product-section')?.classList.remove('product-section--non-compliant');
  cartBtn.closest('.custom-product--content')?.querySelectorAll('.bis_form')?.forEach(frm => {
    frm.classList.remove('hide-noncompl');
  })

if (variant) {
  var defaultText = cartBtnText.dataset.defaultText;
  const v = variant;
  let source = container.querySelector(`.upsell-variant-hidden[data-id="${variant.id}"]`);
  // Custom labels come from the modal markup: the modal's own window.variantMetafields script doesn't run when injected
  const pageMf = v && v.id ? window.variantMetafields?.[String(v.id)] || null : null;
  const mf = {
    alternative_atc_label: source?.dataset.atcLabel || pageMf?.alternative_atc_label,
    alternative_unavailable_label: source?.dataset.unavailableLabel || pageMf?.alternative_unavailable_label
  };
  if (source && source.getAttribute('data-available') === "true") {
    if (variant && variant.sku.indexOf('NONCOMPL-') !== -1) {
      cartBtnText.textContent = "Non-Compliant";
      // cartBtn.classList.add(classes.disabled);
      // cartBtn.disabled = true;
      let explainerTooltip = document.createElement('div');
      explainerTooltip.classList.add('explainer-box');
      explainerTooltip.innerHTML = `
        <p><b>This item cannot be purchased.</b><br>This product contains fire retardants and doesn't comply with Modern Nursery non-toxic standards. <a href="https://www.modernnursery.com/blogs/all/what-are-fire-retardants">Learn more!</a></p>
        `;
      cartBtn.insertAdjacentElement('beforebegin', explainerTooltip);
      cartBtn.closest('.product-section')?.classList.add('product-section--non-compliant');
      cartBtn.closest('.custom-product--content')?.querySelectorAll('.bis_form')?.forEach(frm => {
        frm.classList.add('hide-noncompl');
      });
    } else {
      // Available, enable the submit button and change text
      cartBtn.classList.remove('disabled');
      cartBtn.disabled = false;
      cartBtnText.textContent = mf?.alternative_atc_label || defaultText;
    }
  } else {
    // Sold out, disable the submit button and change text
    cartBtn.classList.add('disabled');
    cartBtn.disabled = true;
    cartBtnText.textContent = mf?.alternative_unavailable_label || theme.strings.soldOut;
    if (variant && variant.sku.indexOf('NONCOMPL-') !== -1) {
      cartBtnText.textContent = "Non-Compliant";
      // cartBtn.classList.add(classes.disabled);
      // cartBtn.disabled = true;
      let explainerTooltip = document.createElement('div');
      explainerTooltip.classList.add('explainer-box');
      explainerTooltip.innerHTML = `
        <p><b>This item cannot be purchased.</b><br>This product contains fire retardants and doesn't comply with Modern Nursery non-toxic standards. <a href="https://www.modernnursery.com/blogs/all/what-are-fire-retardants">Learn more!</a></p>
        `;
      cartBtn.insertAdjacentElement('beforebegin', explainerTooltip);
      cartBtn.closest('.product-section')?.classList.add('product-section--non-compliant');
      cartBtn.closest('.custom-product--content')?.querySelectorAll('.bis_form')?.forEach(frm => {
        frm.classList.add('hide-noncompl');
      });
    }
  } 
} else {
  // The variant doesn't exist, disable submit button
  cartBtn.classList.add('disabled');
  cartBtn.disabled = true;
  cartBtnText.textContent = theme.strings.unavailable;
}
}

// Updated no refunds tooltip


// $('.nr--button').on('click', function(e) {
//   e.stopPropagation();
//   let tooltip = $(this).find('.nr--tooltip');
//   if (tooltip.length < 1) {
//     tooltip = $(this).parent().parent().siblings('.nr--tooltip');
//   }
//   if (tooltip.length < 1) {
//     tooltip = $(this).siblings('.nr--tooltip');
//   }
//   e.preventDefault();
//   if (tooltip.hasClass('show-tooltip') && !tooltip.hasClass('cart-nr--tooltip')) {
//     tooltip.removeClass('show-tooltip');
//   } else {
//     tooltip.addClass('show-tooltip');
//   }
// })


// Flag to prevent reload_data_first() from overwriting a prior variant:change update
let variantChangedBeforeLoad = false;

function getAvailabilityTargets() {
  const availabilityText = document.getElementById('availabilityText');
  const availabilityInput = document.getElementById('availabilityInput');

  if (!availabilityText || !availabilityInput) {
    return null;
  }

  return { availabilityText, availabilityInput };
}

function getAvailabilityDataFromElement(element) {
  if (!element) {
    return null;
  }

  return {
    warehouseAvail: Number(element.getAttribute('data-warehouse')) || 0,
    latencyRange: Number(element.getAttribute('data-latency-range')) || 0,
    shippingLatency: Number(element.getAttribute('data-shipping-latency')) || 0,
    availabilityDate: (element.getAttribute('data-availability-date') || '').substr(0, 10),
    variantInventory: Number(element.getAttribute('data-variant-inventory')) || 0
  };
}

function formatAvailabilityRange(dateFrom, dateTo) {
  return (
    monthNames[dateFrom.getMonth()] + ' ' + dateFrom.getDate() + ', ' + dateFrom.getFullYear() +
    ' - ' +
    monthNames[dateTo.getMonth()] + ' ' + dateTo.getDate() + ', ' + dateTo.getFullYear()
  );
}

function renderAvailabilityRange(targets, dateFrom, dateTo) {
  const formattedRange = formatAvailabilityRange(dateFrom, dateTo);
  targets.availabilityText.textContent = 'Estimated ship date is ' + formattedRange;
  targets.availabilityInput.value = formattedRange;
}

function getAvailabilityRange(data) {
  if (!data) {
    return null;
  }

  let dateFrom;
  let dateTo;
  const compareDate = data.availabilityDate && new Date(data.availabilityDate) < new Date();

  if (data.warehouseAvail > 0) {
    dateFrom = new Date();
    dateTo = new Date();

    switch (dateFrom.getDay()) {
      case 0:
        dateFrom = dateFrom.addHours(24);
        dateTo = dateTo.addHours(48);
        break;
      case 5:
        dateTo = dateTo.addHours(72);
        break;
      case 6:
        dateFrom = dateFrom.addHours(48);
        dateTo = dateTo.addHours(72);
        break;
      default:
        dateTo = dateTo.addHours(24);
    }

    return { dateFrom, dateTo };
  }

  if (data.availabilityDate && data.variantInventory <= 0) {
    if (compareDate) {
      dateFrom = new Date().addHours((14 * 24) + (data.shippingLatency * 24));
    } else {
      dateFrom = new Date(data.availabilityDate).addHours(data.shippingLatency * 24);
    }
  } else {
    dateFrom = new Date().addHours(data.shippingLatency * 24);
  }

  dateTo = new Date(dateFrom).addHours(data.latencyRange * 24);

  return { dateFrom, dateTo };
}

function updateAvailability(data) {
  const targets = getAvailabilityTargets();
  const range = getAvailabilityRange(data);

  if (!targets || !range) {
    return;
  }

  renderAvailabilityRange(targets, range.dateFrom, range.dateTo);
}

// Update Estimated Shipping Date on change
function reload_data(varId) {
  const data = getAvailabilityDataFromElement(document.querySelector(`.esd__container[data-variant-id="${varId}"]`));
  updateAvailability(data);
}

window.addEventListener('load', function(e) {
  // If a variant changed before the page finished loading, don't run the "first" initializer
  if (variantChangedBeforeLoad) return;
  reload_data_first();
})

document.addEventListener('variant:change', function (evt) {
  // Mark that a variant update has occurred before window.onload could run
  variantChangedBeforeLoad = true;

  // Option combination with no matching variant: nothing to update
  if (!evt.detail.variant) return;

  const varId = evt.detail.variant.id;
  const v = evt.detail.variant;
  const mf = v && v.id ? window.variantMetafields?.[String(v.id)] || null : null;
  
  if (evt.detail.variant.available) {
    document.querySelector('.preorder-tag')?.classList.add('hide');
  } else {
    document.querySelector('.preorder-tag')?.classList.remove('hide');
  }

  if (Number(document.querySelector(`.esd__container[data-variant-id="${varId}"]`)?.getAttribute('data-warehouse')) > 0 && v.available === true) {
    document.querySelectorAll('.warehouse--info')?.forEach(itm => {
      itm.classList.remove('hide');
    });
  } else {
    document.querySelectorAll('.warehouse--info')?.forEach(itm => {
      itm.classList.add('hide');
    });
  }

  setTimeout(function () {
    
    reload_data(varId);
    
    if (mf) {
      if (mf.hide_esd === "true") {
        document.querySelector('.product-section').classList.add('hide-esd-var');
      } else {
        document.querySelector('.product-section').classList.remove('hide-esd-var');
      }
    }
  }, 200);
});

function reload_data_first() {
  updateAvailability(getAvailabilityDataFromElement(document.querySelector('.esd--selected')));
}

// Babylist
// $('body').on('change', '.selector-wrapper', function(e) {
//   let variant = bcpo.variant;
//   updateBabylistButton(variant);
//   setTimeout(function() {
//     let points = parseInt($('[data-product-price]').attr('data-amount').replace(/[^0-9.-]+/g,""));
//     $('.crp--amount').text(points);
//   }, 1)
// })
// function updateBabylistButton (variant) {

//   let product = bcpo_product;

//   if (variant) {
//     var data = {
//       images: `${variant.featured_image ? variant.featured_image.src : product.featured_image.src}`,
//       price: `${theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)}`,
//       title: `${product.title} - ${variant.title}`,
//       url: `${window.location}`
//     };
//     $('#AddToBabylist').attr('href', `javascript: bl.addToRegistry(${JSON.stringify(data)})`);
//   }
// }

// $(window).on('load', function() {
//   let el = $('.myregistry > span:not(.mr-newwindowwarn)');
//     let text = el.html();
//     if (text) {
//       let newText = text.replace("Add to Registry", "Add to <span class='mr-label-span'>MYREGISTRY</span>");
//       el.html(newText)
//     }
// })
document.addEventListener('variant:change', function (evt) {
  let variant = evt.detail.variant;
  // Option combination with no matching variant: nothing to update
  if (!variant) return;
  updateBabylistButtonGrid(variant);
  updatePriceAndPoints(evt.detail.variant)
});
function updateBabylistButtonGrid(variant) {
  let variantUrl = replaceVariantParam(window.location.href, variant.id);
  var data = {
    images: `${variant.featured_image.src}`,
    price: `${theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)}`,
    title: `${variant.name}`,
    url: `${variantUrl}`
  };
  
  let targetEl = document.querySelector('.modal--quick-shop.modal--is-active #AddToBabylist-modal') || document.querySelector('#AddToBabylist');
  if (targetEl) {
    targetEl.setAttribute('href', `javascript: bl.addToRegistry(${JSON.stringify(data)})`)
  }
}
function replaceVariantParam(url, newVariant) {
  let [baseWithQuery, hash] = url.split("#");
  let variantPattern = /([?&])variant=[^&]*/;

  if (variantPattern.test(baseWithQuery)) {
    baseWithQuery = baseWithQuery.replace(variantPattern, `$1variant=${newVariant}`);
  } else {
    let separator = baseWithQuery.includes("?") ? "&" : "?";
    baseWithQuery = `${baseWithQuery}${separator}variant=${newVariant}`;
  }

  return hash ? `${baseWithQuery}#${hash}` : baseWithQuery;
}
function updatePriceAndPoints(variant) {
  // variant.price is in cents. We want floor(price/10) with NO rounding.
  // 1) Compute the "points" value in dollars using integer math and FLOOR.
  //    price/10/100 == price/1000  (cents → dollars)
  const pointsDollars = Math.floor(variant.price / 1000);

  // 2) Convert back to cents so formatMoney can render it without decimals.
  const pointsCents = pointsDollars * 100;

  // Use the store's money format but force no decimals
  const noDecimalFormat = theme.settings.moneyFormat.replace(
    /{{\s*amount.*?}}/,
    '{{amount_no_decimals}}'
  );

  const newPoints = theme.Currency.formatMoney(pointsCents, noDecimalFormat);

  // Pick target element (PDP vs Quick Shop)
  let targetEl = document.querySelector('.crp--amount');
  if (document.querySelector('.modal--quick-shop.modal--is-active .crp--amount')) {
    targetEl = document.querySelector(
      `[data-product-id="${variant.featured_image?.product_id}"] .crp--amount`
    );
  }

  if (targetEl) targetEl.innerText = newPoints;
}
// Handle various clicks
document.addEventListener('click', function (e) {
  // PDP - Complementary products
  if (e.target.classList.contains('color-swatch') && e.target.closest('.product-block--complementary')) {
    e.stopPropagation();
    e.preventDefault();
  }
  // Return policy
  if (e.target.classList.contains('nr--button')) {
    e.stopPropagation();
    let tooltip = e.target.querySelector('.nr--tooltip') || e.target.closest('div').querySelector('.nr--tooltip');

    e.preventDefault();
    if (tooltip.classList.contains('show-tooltip') && !tooltip.classList.contains('cart-nr--tooltip')) {
      tooltip.classList.remove('show-tooltip');
    } else {
      tooltip.classList.add('show-tooltip');
    }
  } else {
    let shownTooltip = document.querySelector('.show-tooltip');
    shownTooltip?.classList.remove('show-tooltip');
  }
})
// PDP badges
document.querySelectorAll('.product-certificate')?.forEach(bdg => {
  bdg.addEventListener('click', function (e) {
    let target = e.currentTarget;
    let tooltip = e.currentTarget.querySelector('.certificate-content');
    document.querySelectorAll('.certificate-content').forEach(ctf => {
      ctf.classList.add('certificate-hidden');
    })
    positionTooltipLeftOrRight(target, tooltip);
    bdg.querySelector('.certificate-content').classList.remove('certificate-hidden');
  })
})
document.querySelectorAll('.prcer-close').forEach(cls => {
  cls.addEventListener('click', function (e) {
    e.stopPropagation();
    cls.closest('.certificate-content').classList.add('certificate-hidden');
  })
})
// $('.product-certificate').on('click', function(e) {
//   let target = e.currentTarget;
//   let tooltip = e.currentTarget.querySelector('.certificate-content');
//   $('.certificate-content').addClass('certificate-hidden');
//   positionTooltipLeftOrRight(target, tooltip);
//   $(this).find('.certificate-content').removeClass('certificate-hidden');
// })
// $('.prcer-close').on('click', function(e) {
//   e.stopPropagation();
//   $(this).closest('.certificate-content').addClass('certificate-hidden');



// })

function positionTooltipLeftOrRight(targetElement, tooltipElement) {
  const targetRect = targetElement.getBoundingClientRect();
  const tooltipRect = tooltipElement.getBoundingClientRect();
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  const tooltipWidth = 300;

  let tooltipX;

  if (targetRect.left - tooltipWidth >= 0) {
    // Place tooltip to the left of the target element
    // tooltipX = targetRect.left - tooltipWidth;
  } else if (targetRect.left + targetRect.width + tooltipWidth <= viewportWidth) {
    // Place tooltip to the right of the target element
    tooltipX = targetRect.left;
    tooltipElement.style.left = 0;
    tooltipElement.style.right = "unset";
  } else {
    // Default to placing tooltip on the left
    // tooltipX = targetRect.left - tooltipWidth;
  }
}
// PDP Budnle - expand
document.addEventListener('click', function (e) {
  if (e.target.classList.contains('pdp__bundles-title') || e.target.closest('.pdp__bundles-title')) {
    e.target.classList.toggle('expanded')
  }
})
// let bundleTriggers = document.querySelectorAll('.pdp__bundles .pdp__bundles-title');
// if (bundleTriggers?.length > 0) {
//   bundleTriggers.forEach(btr => {
//     btr.addEventListener('click', function() {
//       btr.classList.toggle('expanded');
//     })
//   })
// }

// Custom slider
document.addEventListener('DOMContentLoaded', function() {
  const sliderContainers = document.querySelectorAll('.slider-container');

  sliderContainers.forEach(function(container) {
    const prevButton = container.querySelector('.slider-nav.prev');
    const nextButton = container.querySelector('.slider-nav.next');
    const slider = container.querySelector('.slider');

    if (!prevButton || !nextButton || !slider) {
      return;
    }

    function updateNavButtons() {
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      prevButton.disabled = slider.scrollLeft <= 0;
      nextButton.disabled = slider.scrollLeft >= maxScrollLeft;
    }

    function scrollSlider(amount) {
      const newScrollLeft = slider.scrollLeft + amount;
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

      if (newScrollLeft < 0) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (newScrollLeft > maxScrollLeft) {
        slider.scrollTo({ left: maxScrollLeft, behavior: 'smooth' });
      } else {
        slider.scrollBy({ left: amount, behavior: 'smooth' });
      }
    }

    let resizeFrame = null;

    prevButton.addEventListener('click', function() {
      scrollSlider(-slider.clientWidth);
    });

    nextButton.addEventListener('click', function() {
      scrollSlider(slider.clientWidth);
    });

    slider.addEventListener('scroll', updateNavButtons, { passive: true });
    window.addEventListener('resize', function() {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = requestAnimationFrame(updateNavButtons);
    });

    updateNavButtons();
  });
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.indexOf('/products/') > -1 && window.location.href.indexOf('?src=') > -1) {
    let targetContainer = document.querySelector('.product-single__meta .product-single__form');
    const urlParams = new URLSearchParams(window.location.search);
    let srcParam = urlParams.get('src');
    let value = '';
    switch(srcParam) {
      case "upsell-modal":
        value = "Cart Upsell";
        break;
      case "bundle-modal":
        value = "PDP Upsell";
        break;
      case "bundle-pdp":
        value = "PDP Upsell";
        break;
      default:
        value = srcParam;
    }
    targetContainer.insertAdjacentHTML("afterBegin",
      `<p style="display:none" class="line-item-property__field"><label for="upsell">Upsell</label><input id="upsell" type="text" name="properties[_Upsell]" value="${value}"></p>`);
  }
});

document.addEventListener("DOMContentLoaded", function() {
  initiateSwatchObserver();
});

function initiateSwatchObserver() {
  const lazyBackgrounds = document.querySelectorAll('.color-swatch[data-bg]');

  if (!lazyBackgrounds.length) {
    return;
  }

  if ("IntersectionObserver" in window) {
      let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                  let lazyBackground = entry.target;
                  lazyBackground.style.backgroundImage = `url(${lazyBackground.dataset.bg})`;
                  lazyBackgroundObserver.unobserve(lazyBackground);
              }
          });
      });

      lazyBackgrounds.forEach(function(lazyBackground) {
          lazyBackgroundObserver.observe(lazyBackground);
      });
  } else {
      // Fallback for browsers that don't support IntersectionObserver
      lazyBackgrounds.forEach(function(lazyBackground) {
          lazyBackground.style.backgroundImage = lazyBackground.dataset.bg;
      });
  }
}
// Bundle scripts
// document.addEventListener('DOMContentLoaded', function(event) {
//       available = document.querySelector(`.bundle-availability[data-variant-id='${selectedVar}']`).getAttribute('data-available');
//       if (available === "false") {
//         btn.classList.add('disabled');
//         btn.setAttribute('disabled', '');
//         btnLabel.innerHTML = "Sold out";
//       }
//       else {
//         btn.classList.remove('disabled');
//         btn.removeAttribute('disabled', '');
//         btnLabel.innerHTML = "Add to cart";
//       }
//     });

//     btn.addEventListener('click', function(e) {
//       e.preventDefault();
      
//       doStuff(btn);
//     })
  
//     document.addEventListener('variant:change', function(evt) {
//       selectedVar = evt.detail.variant.id;
//       available = document.querySelector(`.bundle-availability[data-variant-id='${selectedVar}']`).getAttribute('data-available');
//       if (available === "false") {
//         btn.classList.add('disabled');
//         btn.setAttribute('disabled', '');
//         btnLabel.innerHTML = "Sold out";
//       }
//       else {
//         btn.classList.remove('disabled');
//         btn.removeAttribute('disabled', '');
//         btnLabel.innerHTML = "Add to cart";
//       }
//     });

//   function doStuff(elm) {
//     elm.querySelector('span').innerText = "Adding...";
//     let newObj = [];
//     let selected = mappings[selectedVar];
//     const counts = {};
//     selected.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; });
    
//     for (const [key, value] of Object.entries(counts)) {
//         newObj = [...newObj, {"id": key, "quantity": value, "properties": {"_Bundle listing?": "Yes"}}]
//       }
//     let formData = {"items": newObj};

    
//     fetch(window.Shopify.routes.root + 'cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(formData)
//     })
//     .then(response => {
//     if (response.ok) { 
//       document.dispatchEvent(new CustomEvent('ajaxProduct:added', {}));
//       return response.json();
//      }
//      return Promise.reject(response); 
//       })
//     .catch((error) => {
//       console.error('Error:', error);
//     });
//     }

// Listen for the pplrAddToCartCompleted custom event
window.addEventListener('pplrAddToCartCompleted' , function(e) {
  document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
// check if the add to cart event has fired
})
